<template>
  <b-card no-body
          :bg-variant="bgColor"
          :text-variant="textColor"
  >
    <!-- title and dropdown -->
    <b-card-header class="pb-0">
      <b-card-title>
        <b-button
            v-ripple.400="'rgba(40,93,199,0.15)'"
            variant="flat-primary"
            class="btn-icon"
            @click="updateProjectName"
        >
          <feather-icon icon="EditIcon"/>
        </b-button>
        {{ project.name }}
      </b-card-title>
      <b-card-title right>{{ project.dueDate }}</b-card-title>
    </b-card-header>
    <!--/ title and dropdown -->

    <b-card-body>
      <b-row>
        <b-col
            sm="2"
            class="d-flex flex-column flex-wrap text-center cursor-pointer"
            @click="showTasks('inbox')"
        >
          <h1 class="font-large-2 font-weight-bolder mt-2 mb-0">
            {{ project.tasksCount }}
          </h1>
          <b-card-text>وظایف</b-card-text>
        </b-col>

        <!-- chart -->
        <b-col
            sm="10"
            class="d-flex justify-content-center"
        >

          <!-- apex chart -->
          <vue-apex-charts
              type="radialBar"
              height="270"
              :options="supportTrackerRadialBar.chartOptions"
              :series="supportTrackerRadialBar.series"
          />
        </b-col>
        <!--/ chart -->
      </b-row>

      <!-- chart info -->
      <div class="d-flex justify-content-between">
        <div class="text-center cursor-pointer" @click="showTasks('complete')"
        >
          <b-card-text class="mb-50">
            وظایف انجام شده
          </b-card-text>
          <span class="font-large-1 font-weight-bold">{{ project.doneTasks }}</span>
        </div>
        <div class="text-center cursor-pointer" @click="showTasks('inbox')">
          <b-card-text class="mb-50">
            وظایف باز
          </b-card-text>
          <span class="font-large-1 font-weight-bold">{{ project.doingTasks }}</span>
        </div>
        <div class="text-center">
          <b-card-text class="mb-50">
            آخرین وظیفه انجام شده
          </b-card-text>
          <span class="font-medium-2 font-weight-bold">{{ project.lastDoneTask }}</span>
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BDropdown, BDropdownItem, BCardBody, BRow, BCol, BCardText, BListGroupItem, BButton
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import {$themeColors} from '@themeConfig'
import router from "@/router";
import ripple from "vue-ripple-directive";

export default {
  components: {
    BListGroupItem,
    VueApexCharts,
    BCard,
    BCardHeader,
    BCardTitle,
    BDropdown,
    BDropdownItem,
    BCardText,
    BCardBody,
    BRow,
    BCol,
    BButton
  },
  directives: {
    ripple
  },
  props: {
    project: {
      type: Object,
      required: true

    }
  },
  computed: {
    bgColor() {
      return this.project.tasksCount > 0 && this.project.doneTasks === this.project.tasksCount ? 'success' : 'normal'
    },
    textColor() {
      return this.project.tasksCount > 0 && this.project.doneTasks === this.project.tasksCount ? 'white' : 'black'
    }
  },
  methods: {
    showTasks(page) {
      router.push({path: `/tasks/${page}`, query: {project: this.project.id}})

    },
    updateProjectName() {
      this.$emit('update-project', {id: this.project.id, name: this.project.name})
    }
  },
  data() {
    return {
      trackerData: {},
      supportTrackerRadialBar: {
        series: [this.project.doneTasksPercent],
        chartOptions: {
          plotOptions: {
            radialBar: {
              size: 150,
              offsetY: 20,
              startAngle: -150,
              endAngle: 150,
              hollow: {
                size: '65%',
              },
              track: {
                background: '#fff',
                strokeWidth: '100%',
              },
              dataLabels: {
                name: {
                  offsetY: -5,
                  color: '#5e5873',
                  fontSize: '1rem',
                },
                value: {
                  offsetY: 15,
                  color: '#5e5873',
                  fontSize: '1.714rem',
                },
              },
            },
          },
          colors: [$themeColors.danger],
          fill: {
            type: 'gradient',
            gradient: {
              shade: 'dark',
              type: 'horizontal',
              shadeIntensity: 0.5,
              gradientToColors: [$themeColors.primary],
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100],
            },
          },
          stroke: {
            dashArray: 8,
          },
          labels: ['وظایف انجام شده'],
        },
      },
    }
  },

}
</script>
